<template>
  <div style="height: 100%">
    <div id="container" style="width: 100%; height: 100%"></div>
  </div>
</template>

<script>
import { getToken } from '../utils/auth'
import { equiphistory, equipinfo } from '../service/getData'
import moment from 'moment'
import { Switch } from 'vant'
// 信息窗
var infoWindow = null
// 折线
var polyline = null
// 点击marker弹窗
function markerClick(e, _this) {
  infoWindow.setContent(e.target.content)
  infoWindow.open(_this.map, e.target.getPosition())
  _this.$modal.show('modal')
}
var satelliteLayer = new AMap.TileLayer.Satellite()
export default {
  components: {
    [Switch.name]: Switch
  },
  name: 'app',
  data() {
    return {
      map: null,
      markers: [],
      checked: localStorage.getItem('layer') ? JSON.parse(localStorage.getItem('layer')) : true,
      tp: null,
      info: null,
      deviceList: null,
      listPoint: null,
      // 开始时间
      dbt:
        null ||
        moment()
          .subtract(6, 'month')
          .format('YYYY-MM-DD'),
      // 结束时间
      edt: null || moment().format('YYYY-MM-DD'),
      // 路由来的params/设备ID
      equipid: this.$route.params.mapId
    }
  },
  methods: {
    onSwitchChange(checked) {
      localStorage.setItem('layer', JSON.stringify(checked))
      if (checked) {
        this.map.add(satelliteLayer)
      } else {
        this.map.remove(satelliteLayer)
      }
    },

    // 标记点
    addMarker(point, i) {
      let marker = new AMap.Marker({
        icon: '/static/point.png',
        position: point,
        offset: new AMap.Pixel(0, 0)
      })
      let equipname = this.info.enm
      let contentHTML = `<div>设备名称：${equipname}</div><div>经纬度 ${this.deviceList[i]['jdt']},${this.deviceList[i]['wdt']}</div>`
      this.tp.map((n, index) => {
        let no = index
        contentHTML += `<div>${n.tnm}：${this.deviceList[i]['col' + no]}</div>`
      })

      contentHTML = contentHTML + `<div>时间：${this.deviceList[i]['createtime']}</div>`
      marker.content = contentHTML
      marker.on('click', e => markerClick(e, this))
      this.markers.push(marker)
    },
    async equiphistory() {
      infoWindow && infoWindow.close()
      // 清除marker
      if (this.map) {
        this.map.remove(polyline)
        this.map.remove(this.markers)
        this.markers = []
      }
      this.equipid = this.$route.params.mapId
      let loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      let tp = await equipinfo(this.equipid)
      this.tp = tp.data.tp
      this.info = tp.data
      let result
      if (this.equipid == 36 || this.equipid == 37) {
        result = await equiphistory(
          moment()
            .subtract(2, 'year')
            .format('YYYY-MM-DD'),
          this.edt,
          this.equipid,
          1,
          99999
        )
      } else {
        result = await equiphistory(this.dbt, this.edt, this.equipid, 1, 99999)
      }

      loading.close()
      this.deviceList = result.data.total ? JSON.parse(result.data.data) : []
      if (!this.deviceList || this.deviceList.length === 0) {
        infoWindow.close()
      }
      this.listPoint = [] //列表的坐标点

      this.deviceList = this.deviceList.filter(item => {
        if (+item.jd === 1 || +item.jd === 0 || +item.wd === 1 || +item.wd === 0) {
          return false
        } else {
          return true
        }
      })
      this.deviceList.map(item => {
        let arr = []
        arr.push(`${(item.jdchar === 'W' && '-') || ''}${item.jd}`)
        arr.push(`${(item.wdchar === 'S' && '-') || ''}${item.wd}`)

        let LngLat, jd, wd
        jd = item.jd
        wd = item.wd
        if (item.jdchar === 'W') {
          jd = 360 - item.jd
        }
        if (item.wdchar === 'S') {
          wd = -item.wd
        }
        LngLat = new AMap.LngLat(jd, wd, true)
        // 添加折线路径
        this.listPoint.push(LngLat)
      })

      this.map =
        this.map ||
        new AMap.Map('container', {
          zooms: [3, 18],
          resizeEnable: true,
          features: ['bg', 'road', 'building', 'point'],
          expandZoomRange: true
        })
      let layer = '' //JSON.parse(localStorage.getItem('layer'))
      if (layer || layer === null) {
        this.map.add([satelliteLayer])
      } else {
        this.map.remove(satelliteLayer)
      }

      // 创建折线实例
      polyline = new AMap.Polyline({
        path: this.listPoint,
        borderWeight: 1, // 线条宽度，默认为 1
        strokeColor: 'white', // 线条颜色
        lineJoin: 'round' // 折线拐点连接处样式
      })
      // 将折线添加至地图实例
      this.map.add(polyline)
      this.listPoint.map((point, index) => {
        this.addMarker(point, index)
      })
      // this.map.setMapStyle('amap://styles/3e3af33551cdd2ec5f1daa9e87304454')
      this.map.add(this.markers)
      this.map.setFitView()
      // this.map.setZoom(5)

      this.listPoint && this.listPoint.length > 0 && this.map.setCenter(this.listPoint.slice(-1)[0])

      // this.markers &&
      //   this.markers.length > 0 &&
      //   AMap.event.trigger(this.markers.slice(-1)[0], 'click', {
      //     target: this.markers.slice(-1)[0]
      //   })
    }
  },
  watch: {
    // 监听map页面路由变化
    async $route() {
      infoWindow = new AMap.InfoWindow({
        offset: new AMap.Pixel(0, 0)
      })
      await this.equiphistory()
    }
  },
  mounted() {
    if (!getToken()) {
      this.$router.push('/login')
      return
    }
    setTimeout(async () => {
      infoWindow = new AMap.InfoWindow({
        offset: new AMap.Pixel(0, 0)
      })
      await this.equiphistory()
    }, 500)
  }
}
</script>
<style lang="scss" scoped>
::v-deep .amap-layers {
  .amap-satellite {
    filter: brightness(0.5) !important;
  }
}
::v-deep .amap-info-contentContainer {
  .amap-info-content {
    position: relative;
    background: #383a49;
    padding: 10px 18px 10px 10px;
    line-height: 1.4;
    overflow: auto;
    border: 1px solid #285e9c;
    border-radius: 8px;
    color: white;
  }
}
::v-deep .bottom-center .amap-info-sharp {
  bottom: 0;
  left: 50%;
  margin-left: -8px;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: 8px solid #313744;
}
#map {
  background: white;
  height: 90%;
}
</style>
<style>
.amap-marker-label {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  text-align: center;
  line-height: 20px;
  font-size: 16px;
  background: #3e95fa;
  color: white;
}
</style>
